import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#D17F26" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/profile.php?id=100068869598727">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Oz Korean Restaurant Facebook"
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/oz.restaurant/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Oz Korean Restaurant Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#D17F26" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/profile.php?id=100068869598727">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Oz Korean Restaurant Facebook"
                hover
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/oz.restaurant/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Oz Korean Restaurant Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
